export default __webpack_public_path__ + "static/media/5.7a92e496.jpg";